import React, { forwardRef } from 'react';

const WebformActions = forwardRef(({disabled, disabledCallback}, ref) => {
    return (
        <button 
            ref={ref}
            type="submit" 
            className={`button button--primary${disabled ? ` disabled` : ``}`} 
        >
            Envoyer
        </button>
    )
})

export default WebformActions
